import Box from '@app/components/common/Box';
import LinesBeforeButton from '../LinesBeforeButton';
import SpacesBeforeButton from '../SpacesBeforeButton';
import { useDndMonitor } from '@dnd-kit/core';
import { useState } from 'react';

const ModifierItemLineAndSpace = ({
  linesBefore,
  spacesBefore,
  onButtonClick,
}: {
  linesBefore: number;
  spacesBefore: number;
  onButtonClick: (field: 'linesBefore' | 'spacesBefore') => void;
}) => {
  const [show, setShow] = useState(true);

  useDndMonitor({
    onDragStart: () => {
      setShow(false);
    },
    onDragEnd: () => {
      setShow(true);
    },
  });
  if (!show) return null;
  return (
    <Box
      csx={{
        padding: '1px 5px 0px 0px',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        alignSelf: 'flex-start',
      }}>
      <LinesBeforeButton
        onClick={() => {
          onButtonClick('linesBefore');
        }}
        count={linesBefore > 0 ? linesBefore : 0}
      />
      <SpacesBeforeButton
        onClick={() => {
          onButtonClick('spacesBefore');
        }}
        count={spacesBefore > 0 ? spacesBefore : 0}
      />
    </Box>
  );
};

export default ModifierItemLineAndSpace;
